export const data = {
  Today: "Today",
  creditCardText: "Add Card Details",
  cardAdd: "Add Card",
  enterAmount: "Enter Amount",
  proceed: "Proceed",
  Note: "Note :",
  Sno: "Sno",
  bbpsId: "BBPS ID",
  createL: "Create Link",
  ntarBizzId: "WYTO ID",
  enterPay: "Enter Details To Pay",
  UL: "Unique Link",
  desc: "Description",
  Ferry: "Ferry Booking",
  conFee: "Convenience Fee",
  suspicious: "Please report this payment link if you find it suspicious",
  Done: "Done",
  dueDate: "Due Date",
  upiText:
    "Open your UPI app to approve the payment request before the timer runs out",
  creditChange: "Please Provide 16 Digit Credit Card Number",
  meId: "Merchant ID",
  onlythree: "Only 3 bank details can be added.",
  RId: "Reference ID",
  NRF: "No Result Found",
  upiIdText: "It will take some time to process. Please wait patiently.",
  showHistory: "Your history will appear here",
  vendorMobile: "Mobile Number (Mandatory)",
  bankAdd: "Add Bank Details",
  closeBalance: "Closing Balance",
  seriveDown: "Service Down Under Maintenance. Please Try Later",
  tID: "Transaction ID",
  Beneficiary: "Beneficiary Name",
  cusNo: "Customer Name :",
  openBalance: "Opening Balance",
  Save: "Save",
  billNo: "Bill Amount :",
  SubService: "SubService",
  PayTime: "Payment Time",
  ntarT: "WYTO Tn Id",
  nos: "No's",
  Reason: "Reason",
  state: "Statement",
  billDate: "Bill Date",
  selectPayMethod: "Select Payment method",
  updateD: "Update Details",
  sub: "Submit",
  from: "From",
  link: "Links",
  paidV: "Paid via",
  vendorPan: "PAN Number (Optional)",
  vendor: "Enter Your Account number",
  confirmD: "Confirm Details",
  soon: "Coming Soon !",
  Referral: "Referral",
  Pay: "Pay",
  noTrans: "No Transactions",
  paidF: "Paid From",
  verify: "Verified",
  Dashboard: "Dashboard",
  PayBills: "Pay Bills",
  BILLPAYMENTS: "BILL PAYMENTS",
  enterIfsc: "Enter IFSC Code",
  settlements: "settlements",
  bill: "Bill Payments",
  gp: "Get Paid",
  pos: "POS",
  COLLECT: "COLLECT",
  user: "User's",
  payL: "Payment Links",
  payout: "Payout's",
  account: "Account",
  ActiveQR: "Active QR",
  Analytics: "Analytics",
  RequestA: "Request Access",
  continue: "Continue",
  PAYOUTS: "PAYOUTS",
  PARTNER: "PARTNER",
  monthlyV: "Monthly View",
  quick: "Quick Send",
  Fastag: "Fastag",
  Transactions: "Transactions",
  notifi: "Recent BBPS",
  recentU: "Recent Transactions",
  Notify: "Notify Me",
  refer: "Refer User",
  clear: "clear",
  send: "send",
  refCount: "Referral Count",
  confirmDe: "Confirm Details",
  confi: "confirm",
  tds: "TDS",
  totalLinkMoney: "Total Collected Money",
  no: "No's",
  mobile: "Mobile Number",
  pan: "PAN Number",
  AccountName: "Account Name",
  AccountNo: "Account No",
  withdraw: "Withdraw Amount",
  with: "Withdraw",
  ifsc: "IFSC Code",
  secureCard: "Secure my card as per RBI guidelines.",
  learn: "Learn More",
  payNote: "You Can Apply your wallet balance at checkout to instantly",
  lowerPay: "lower your payable amount!",
  noData: "No Data Found",
  notified: "Get Notified",
  noRecent: "No Recents Found",
  Service: "Service",
  recents: "Recents",
  walletBal: "Wallet Balance",
  Electricity: "Electricity",
  amountPay: "Amount Paying",
  select: "Select an option",
  Invalid: "Invalid",
  actual: "Actual Amount:",
  noCredit: "No Credit Cards Found",
  comingsoon: "Coming soon!!",
  somethingWrong: "Something Went Wrong. Please try again...",
  loginFound: "You Have Logged in on another device! Click ok to login again",
  processPay: "Payment is Processing... Please wait.",
  share: "Share the Link",
  pNow: "Pay Now",
  all: "All",
  transDate: "transaction Date:",
  launch: "When we Launch",
  Outstanding: "Outstanding Amount :",
  Services: "Services",
  mID: "Merchant Id:",
  sn: "S.no",
  dash: "Go Back homepage",
  confirm: "Confirm To Pay",
  paying: "Paying To",
  dashOops: "Oops! The page you're looking for doesn't exist.",
  Help: "Help",
  lg: "Log Out",
  cr: "Credited",
  dr: "Debited",
  tod: "Today",
  amount: "Amount",
  payDetails: "Payment Details",
  CollectedMoney: "Collected Money",
  throughLink: "Total Payments through Links",
  settlement: "Settlement",
  actQ: "Activate QR",
  payOption: "Payment Options",
  creditBill: "Credit Card Bill Payment",
  back: "Back",
  crdr: "Credit/Debit Card",
  TotalPay: "Total Payment",
  history: "History",
  Unsettled: "Unsettled Balance",
  Balance: "Balance",
  down: "Download",
  Date: "Date",
  status: "Status",
  uNum: "UTR Number",
  next: "Next",
  Paid: "Paid To",
  ntar: "WYTO PRIVATE LIMITED",
  addPayee: "Add Payee Details",
  add: "Add",
  UTR: "UTR",
  NoPayee: "No Payees Found",
  serviceUnavailable:
    "This Service is under Maintainance. Please contact our support team for further assistance.",
  tAmount: "Total Amount",
  oops: "“OOPS” Link was Expired...!",
};
